import { render, staticRenderFns } from "./specialGoodsDialog.vue?vue&type=template&id=1b86ff4c&"
import script from "./specialGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./specialGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b86ff4c')) {
      api.createRecord('1b86ff4c', component.options)
    } else {
      api.reload('1b86ff4c', component.options)
    }
    module.hot.accept("./specialGoodsDialog.vue?vue&type=template&id=1b86ff4c&", function () {
      api.rerender('1b86ff4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/specialGoodsDialog.vue"
export default component.exports